import React from 'react';
import {FooterButton} from 'components/layout';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import PropTypes from 'prop-types';
import NotePopover from 'components/notes/NotePopover';
import CustomerModel from 'models/customer';
import PoolModel from 'models/pool';
import AnalysisModel from 'models/analysis';
import NoteModal from 'components/notes/NoteModal';
import poolApi from 'api/pool';
import analysisApi from 'api/analysis';
import waterTesterApi from 'api/waterTester';
import {getAllNotes, saveNote} from 'api/note';
import Note from 'models/note';
import {newNotesEnabled} from 'features';
import path from 'path';
import events from '../../../lib/events.js';


class NoteFooter extends React.Component {
  static propTypes = {
    customer: PropTypes.instanceOf(CustomerModel).isRequired,
    pool: PropTypes.instanceOf(PoolModel),
    analysis: PropTypes.instanceOf(AnalysisModel),
    intl: intlShape.isRequired,
  };

  state = {
    visible: false,
    edit: false,
    note: undefined,
    pools: [],
    analyses: [],
    waterTesters: [],
    notes: [],
  };

  componentDidMount() {
    this.listener = events.subscribe('note.populate.modal', () =>{this.fetchData(this.props.customer);});
    this.fetchData(this.props.customer);
    window.addEventListener('click', this.globalClickHandler);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.customer !== this.props.customer) {
      this.fetchData(nextProps.customer);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.globalClickHandler);
    if (this.listener) {
      this.listener.remove();
    }
  }

  fetchData = customer => {
    return Promise.all([
      poolApi.getList(customer.id),
      analysisApi.customerSummary(customer.id),
      waterTesterApi.getWaterTesters(),
      getAllNotes(customer.id),
    ])
      .then(([pools, analyses, waterTesters, notes]) => {
        this.setState({pools, analyses, waterTesters, notes});
      });
  };

  openPopover = () => {
    this.setState({
      visible: true,
    });
  };

  togglePopover = () => {
    if (this.state.visible || this.state.edit) {
      this.closeAll();
      return;
    }

    this.openPopover();
  };

  closeModal = () => {
    this.setState({
      note: undefined,
      edit: false,
    });
  };

  closeAll = () => {
    this.setState({
      visible: false,
      edit: false,
      note: undefined,
    });
  };

  globalClickHandler = e => {
    // TODO: ensure we have polyfill for this for ie/edge
    if (!e.target.closest('.notes__container') && (this.state.visible || this.state.edit)) {
      this.closeAll();
    }
  };

  addNote = () => this.editNote(new Note({}))();

  editNote = note => () => {
    this.setState({
      visible: true,
      edit: true,
      note,
    });
  };

  save = note => {
    note.customerID = this.props.customer.id;
    note.analysisID = note.selectedAnalysis;
    note.systemID = note.selectedPool;

    return saveNote(note)
      .then(data => {
        if (!data) {
          return;
        }

        note.id = data;

        const notes = this.state.notes.filter(x => x.id !== note.id);

        notes.unshift(note);

        this.setState({notes});
        this.closeAll();
      });
  };

  render() {
    let {visible, edit, pools, analyses, notes, waterTesters, note} = this.state;
    const {analysis, pool, customer} = this.props;
    const {formatMessage} = this.props.intl;

    if(!!waterTesters) {
      waterTesters = [{
        key: -1,
        name: formatMessage({id: 'timeline.notes.select.author'}),
      }, ...waterTesters];
    }

    if (!newNotesEnabled) {
      return <FooterButton
        label={<FormattedMessage id='general.notes' />}
        icon='bl bl-2x bl-notes'
        onClick={() => window.location.hash = path.join('customer', customer.id, 'notes')}/>;
    }

    const noteCount = (notes || [])
      .filter(x => {
        if (analysis && analysis.id) {
          return x.analysisID === analysis.id;
        }

        if (pool && pool.id) {
          return !x.analysisID && x.systemID && x.systemID === pool.id;
        }

        return !x.analysisID && !x.systemID;
      }).length;

    return <div className='notes__container'>
      {visible ?
        <NotePopover {...this.props}
                     notes={notes}
                     addNote={this.addNote}
                     editNote={this.editNote} /> :
        null}
      {edit ?
        <NoteModal {...this.props}
                   note={note}
                   pools={pools}
                   analyses={analyses}
                   waterTesters={waterTesters}
                   save={this.save}
                   closeModal={this.closeModal}/> :
        null}
      <FooterButton onClick={this.togglePopover}
                    icon='bl bl-notes fa-2x'
                    label={<FormattedMessage id='general.notes'/>}>
        {noteCount ? <div className='notes__count'>{noteCount}</div> : null}
      </FooterButton>
    </div>;
  }
}

export default injectIntl(NoteFooter);
